"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HubspotConversionTouchPointDialog = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_use_hubspot_form_1 = require("@aaronhayes/react-use-hubspot-form");
var Dialog_1 = require("./Dialog");
var HubspotConversionTouchPointDialogBase_1 = require("./HubspotConversionTouchPointDialogBase");
/**
 * @public
 */
exports.HubspotConversionTouchPointDialog = function (props) {
    var submitButtonClasses = "hs-button primary large " + (props.submitButtonClass || "s-hs-submit");
    var onDialogSubmit = function () {
        var submitBtn = document.getElementsByClassName(submitButtonClasses)[0];
        submitBtn === null || submitBtn === void 0 ? void 0 : submitBtn.click();
    };
    return (react_1.default.createElement(Dialog_1.Dialog, { displayCloseButton: true, onCancel: props.onClose, submitOnEnterKey: true, onSubmit: onDialogSubmit, className: "conversion-touch-point-dialog s-conversion-touch-point-dialog" },
        react_1.default.createElement(react_use_hubspot_form_1.HubspotProvider, null,
            react_1.default.createElement(HubspotConversionTouchPointDialogBase_1.HubspotConversionTouchPointDialogBase, tslib_1.__assign({}, props, { submitButtonClass: submitButtonClasses })))));
};
//# sourceMappingURL=HubspotConversionTouchPointDialog.js.map